/* eslint-disable @angular-eslint/component-selector */
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DriverDocument, DriverDocumentModalData } from 'src/app/models/driverDocument';

@Component({
  selector: 'megastore-add-driver-document',
  templateUrl: './add-driver-document.component.html',
  styleUrls: ['./add-driver-document.component.scss']
})
export class AddDriverDocumentComponent implements OnInit {
  driverDocumentForm!: FormGroup;
  isEdit: boolean = false;
  modalTitle: string = 'AddRequiredDocument';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddDriverDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DriverDocumentModalData
  ) {}

  ngOnInit(): void {
    this.isEdit = this.data?.isEdit || false;
    this.modalTitle = this.isEdit ? 'EditRequiredDocument' : 'AddRequiredDocument';
    this.initForm();
  }

  initForm(): void {
    this.driverDocumentForm = this.fb.group({
      documentName: ['', [Validators.required]],
      documentType: ['Driver', [Validators.required]],
      requiredType: ['mandatory'],
      required: [false],
      documentNumberRequired: [false],
      issueDateRequired: [false],
      expiryDateRequired: [false]
    });

    // If editing, populate the form with existing data
    if (this.isEdit && this.data?.document) {
      this.driverDocumentForm.patchValue({
        documentName: this.data.document.documentName,
        documentType: this.data.document.documentType,
        requiredType: this.data.document.requiredType || 'mandatory',
        required: this.data.document.required || false,
        documentNumberRequired: this.data.document.documentNumberRequired || false,
        issueDateRequired: this.data.document.issueDateRequired || false,
        expiryDateRequired: this.data.document.expiryDateRequired || false
      });
    }
  }

  submitDoc(): void {
    if (this.driverDocumentForm.valid) {
      const formValue = this.driverDocumentForm.value;
      
      const documentData: DriverDocument = {
        documentName: formValue.documentName,
        documentType: formValue.documentType,
        requiredType: formValue.requiredType,
        required: formValue.required,
        documentNumberRequired: formValue.documentNumberRequired,
        issueDateRequired: formValue.issueDateRequired,
        expiryDateRequired: formValue.expiryDateRequired
      };

      // If editing, preserve the _id
      if (this.isEdit && this.data?.document?._id) {
        documentData._id = this.data.document._id;
      }

      this.dialogRef.close(documentData);
    } else {
      this.driverDocumentForm.markAllAsTouched();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
